import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Represents relationships between employees and other employees who serve as some kind of leader',
    name: 'Personnel Leaders',
    partialId: PartialId.Standard.create('personnel_leaders'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
